import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19 24C18.686 24 18.389 23.852 18.2 23.6L15.2 19.6C15.07 19.427 15 19.216 15 19V5H23V19C23 19.216 22.93 19.427 22.8 19.6L19.8 23.6C19.611 23.852 19.314 24 19 24Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 0H16C15.448 0 15 0.448 15 1V3H23V1C23 0.448 22.552 0 22 0Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 0H2C1.4 0 1 0.4 1 1V5H5V7H1V9H4V11H1V13H5V15H1V17H4V19H1V23C1 23.6 1.4 24 2 24H10C10.6 24 11 23.6 11 23V1C11 0.4 10.6 0 10 0Z",
  class: "tw-text-primary-200",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }